import React from "react";
import BrowseCapontComponent from "../components/capont/CapontOnt";

export default function CapontPage() {
  return <BrowseCapontComponent />;
}
